import { C as Carousel } from "./carousel-27ebdbe1.js";
const listen = (el, event, handler) => {
  if (!el)
    return () => {
    };
  el.addEventListener(event, handler);
  return () => el.removeEventListener(event, handler);
};
const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));
const qs = (selector, root = document) => root.querySelector(selector);
const add = (elOrEls, className) => {
  var _a;
  if (!elOrEls)
    return;
  if (typeof elOrEls.forEach === "function") {
    elOrEls.forEach((el) => {
      var _a2;
      return (_a2 = el == null ? void 0 : el.classList) == null ? void 0 : _a2.add(className);
    });
    return;
  }
  (_a = elOrEls == null ? void 0 : elOrEls.classList) == null ? void 0 : _a.add(className);
};
const remove = (elOrEls, className) => {
  var _a;
  if (!elOrEls)
    return;
  if (typeof elOrEls.forEach === "function") {
    elOrEls.forEach((el) => {
      var _a2;
      return (_a2 = el == null ? void 0 : el.classList) == null ? void 0 : _a2.remove(className);
    });
    return;
  }
  (_a = elOrEls == null ? void 0 : elOrEls.classList) == null ? void 0 : _a.remove(className);
};
const contains = (el, className) => {
  var _a;
  return (_a = el == null ? void 0 : el.classList) == null ? void 0 : _a.contains(className);
};
const selectors = {
  navItems: ".featured-collection-slider__navigation-list-item",
  sliderContainer: ".carousel",
  navButtons: ".carousel__navigation-buttons"
};
const classes = {
  selected: "selected",
  visible: "visible"
};
class FeaturedCollectionSlider {
  constructor(container) {
    this.container = container;
    this.events = [];
    this.carousels = [];
    this._handleNavButton = this._handleNavButton.bind(this);
    this._initCarousels();
  }
  _initCarousels() {
    const { productsPerView, mobileProductsPerView } = this.container.dataset;
    this.perView = parseInt(productsPerView || "0", 10) || 2;
    this.mobilePerView = (parseInt(mobileProductsPerView || "0", 10) || 2) * 1.27;
    this.carouselsElements = qsa(selectors.sliderContainer, this.container);
    this.navItems = qsa(selectors.navItems, this.container);
    this.navigationButtons = qsa(selectors.navButtons, this.container);
    this.navItems.forEach((button) => {
      this.events.push(listen(button, "click", this._handleNavButton));
    });
    this.carouselsElements.forEach((containerEl, index) => {
      const navigationWrapper = qs(
        `[data-navigation="${index}"]`,
        this.container
      );
      const nextButton = navigationWrapper ? qs("[data-next]", navigationWrapper) : null;
      const prevButton = navigationWrapper ? qs("[data-prev]", navigationWrapper) : null;
      const scrollbar = qs(`[data-scrollbar="${index}"]`, this.container) || null;
      this.carousels.push(
        Carousel(containerEl, {
          slidesPerView: this.mobilePerView,
          spaceBetween: 20,
          navigation: nextButton && prevButton ? {
            nextEl: nextButton,
            prevEl: prevButton
          } : false,
          scrollbar: scrollbar ? {
            el: scrollbar,
            draggable: true
          } : false,
          breakpoints: {
            768: {
              slidesPerView: this.perView === 5 || this.perView === 4 ? this.perView - 1 : this.perView
            },
            1200: {
              slidesPerView: this.perView
            }
          }
        })
      );
    });
  }
  _handleNavButton(e) {
    e.preventDefault();
    const { navigationItem } = e.currentTarget.dataset;
    if (!contains(e.currentTarget, classes.selected)) {
      this._hideAll();
      this._show(parseInt(navigationItem, 10));
    }
  }
  _hideAll() {
    remove(this.navItems, classes.selected);
    remove(this.navigationButtons, classes.visible);
    remove(this.carouselsElements, classes.visible);
  }
  _show(index) {
    const navigationWrapper = qs(
      `[data-navigation="${index}"]`,
      this.container
    );
    const collection = qs(`[data-collection="${index}"]`, this.container);
    const navigationItem = qs(
      `[data-navigation-item="${index}"]`,
      this.container
    );
    add(navigationWrapper, classes.visible);
    if (navigationItem)
      add(navigationItem, classes.selected);
    add(collection, classes.visible);
  }
  destroy() {
    this.carousels.forEach((swiper) => {
      var _a;
      return (_a = swiper == null ? void 0 : swiper.destroy) == null ? void 0 : _a.call(swiper);
    });
    this.events.forEach((unsubscribe) => unsubscribe());
  }
}
const initFeaturedCollectionSliders = () => {
  const containers = qsa('[data-section-type="featured-collection-slider"]');
  containers.forEach((container) => {
    if (container.__featuredCollectionSliderInstance)
      return;
    container.__featuredCollectionSliderInstance = new FeaturedCollectionSlider(container);
  });
};
initFeaturedCollectionSliders();
